import type { TFunction } from 'i18next';

import { GAP_SIZE, IconSize, TextVariant } from './constants';

export const getIconSize = ({ height, width }: { width: number; height: number }) => {
  if (height >= IconSize.L && width >= IconSize.L) {
    return IconSize.L;
  }

  if (height >= IconSize.M && width >= IconSize.M) {
    return IconSize.M;
  }

  if (height >= IconSize.S && width >= IconSize.S) {
    return IconSize.S;
  }

  return 0;
};

export const getTextVariant = ({ height, width }: { width: number; height: number }) => {
  const SINGLE_LINE_TEXT_HEIGHT = 32;
  const iconSize = getIconSize({ height, width });
  const LONG_TEXT_WIDTH = 300;
  const SHORT_TEXT_WIDTH = 135;

  // vertical text have 2 lines of text
  if (height >= 2 * SINGLE_LINE_TEXT_HEIGHT + GAP_SIZE + iconSize && width >= LONG_TEXT_WIDTH) {
    return TextVariant.Vertical;
  }

  // 2 lines of text
  if (height >= 2 * SINGLE_LINE_TEXT_HEIGHT && width >= LONG_TEXT_WIDTH + GAP_SIZE + iconSize) {
    return TextVariant.Horizontal;
  }

  // 1 line of text
  if (height >= SINGLE_LINE_TEXT_HEIGHT && width >= LONG_TEXT_WIDTH + SHORT_TEXT_WIDTH + GAP_SIZE + iconSize) {
    return TextVariant.Horizontal;
  }

  return TextVariant.None;
};

export const getLoadingMediaErrorMsg = (t: TFunction) =>
  t('Failed to load media. If you are using Ad Block turn it off and try again.');
